import React from 'react';
import { Switch } from 'react-router-dom';

import { useSelector } from 'react-redux';
import Route from './Route';

import { routesEndpoints } from './endpoint';

import SignIn from '../../../pages/SignIn';
import SignUp from '../../../pages/SignUp';
import Panel from '../../../pages/Panel';
import ProductList from '../../../pages/ProductList';
import ProductView from '../../../pages/ProductView';
import ForgotPassword from '../../../pages/ForgotPassword';
import Checkout from '../../../pages/Checkout';
import Summary from '../../../pages/Summary';
import Home from '../../../pages/Home';
import Account from '../../../pages/Account';
import { StoreState } from '../../../store/createStore';
import Payment from '../../../pages/Account/Payment';

import MobileHome from '../../../pages/MobileHome';
import Master from '../../../layout/Master';
import SignUpStep04 from '../../../pages/SignUp/SignUpStep04';
import SignUpStep05 from '../../../pages/SignUp/SignUpStep05';
import StoreLocator from '../../../pages/StoreLocator';
import AccountAddress from '../../../pages/Account/Address';
import SummaryFinish from '../../../pages/Summary/SummaryFinish';
import Order from '../../../pages/Order';
import OrderDetail from '../../../pages/Order/OrderDetail/v2';
import CheckoutRemake from '../../../pages/CheckoutRemake';
import Agreements from '../../../pages/Agreements';

import Favorite from '../../../pages/Account/Favorite';
import Agreement from '../../../pages/Agreement';
import NewCheckout from '../../../pages/NewCheckout';
import NewAccount from '../../../pages/NewAccount';
import ResetPassword from '../../../pages/ResetPassword';

const Routes: React.FC = ({children}: {children?: React.ReactNode}) => {
  const { openMenu } = useSelector((state: StoreState) => state.parameter);
  const { agreement, isSignedIn } = useSelector((state: StoreState) => state.auth);

  return (
    <Master>
      {openMenu ? (
        <div style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }} />
      ) : (
        <>
          {!agreement && isSignedIn ? <Agreement /> : (
            <Switch>
                <Route path={routesEndpoints.HOME} exact component={Home} />
                <Route path="/mobile" exact component={MobileHome} />
                <Route
                  path={routesEndpoints.PRODUCTS}
                  exact
                  component={ProductList}
                />
                <Route
                  path={routesEndpoints.PRODUCT}
                  exact
                  component={ProductView}
                />
                <Route
                  path={routesEndpoints.AGREEMENTS}
                  exact
                  component={Agreements}
                />
                <Route
                  path={routesEndpoints.AGREEMENT}
                  exact
                  component={Agreement}
                />
                <Route
                  path={routesEndpoints.CHECKOUT}
                  exact
                  component={Checkout}
                  isPrivate
                />
                <Route
                  path={routesEndpoints.NEW_CHECKOUT}
                  exact
                  component={NewCheckout}
                  isPrivate
                />
                <Route
                  path={routesEndpoints.SUMMARY}
                  exact
                  component={Summary}
                  isPrivate
                />
                <Route
                  path={routesEndpoints.SUMMARY_FINISH}
                  exact
                  component={SummaryFinish}
                  isPrivate
                />
                <Route
                  path={routesEndpoints.ACCOUNT}
                  exact
                  component={Account}
                  isPrivate
                />
                <Route
                  path={routesEndpoints.NEW_ACCOUNT}
                  component={NewAccount}
                  isPrivate
                />
                <Route
                  path={routesEndpoints.ACCOUNT_PAYMENT}
                  exact
                  component={Payment}
                  isPrivate
                />
                <Route
                  path={routesEndpoints.ACCOUNT_ADDRESS}
                  exact
                  component={AccountAddress}
                  isPrivate
                />
                <Route
                  path={routesEndpoints.ACCOUNT_FAVORITE}
                  exact
                  component={Favorite}
                  isPrivate
                />
                <Route path={routesEndpoints.SIGNIN} exact component={SignIn} />
                <Route path={routesEndpoints.SIGNUP} exact component={SignUp} />
                <Route path={routesEndpoints.PAINEL} exact component={Panel} />
                <Route
                  path={routesEndpoints.FORGOT_PASSWORD}
                  exact
                  component={ForgotPassword}
                  isPrivate
                />
                <Route
                  path={routesEndpoints.VERIFICATION_MAIL}
                  exact
                  component={SignUpStep04}
                  isPrivate
                />
                <Route
                  path={routesEndpoints.CONFIRMATION_MAIL}
                  exact
                  component={SignUpStep05}
                />
                <Route
                  path={routesEndpoints.STORE_LOCATOR}
                  exact
                  component={StoreLocator}
                />
                <Route
                  path={routesEndpoints.ORDERS}
                  exact
                  component={Order}
                  isPrivate
                />
                <Route
                  path={routesEndpoints.ORDERS_DETAIL}
                  exact
                  component={OrderDetail}
                  isPrivate
                />
                <Route
                  path={routesEndpoints.CHECKOUT_REMAKE}
                  exact
                  component={CheckoutRemake}
                  isPrivate
                />
                <Route
                  path={routesEndpoints.REDEFINE_PASSWORD}
                  exact
                  component={ResetPassword}
                />
                {children && (
                  children
                )}
            </Switch>
          )}
        </>
      )}
    </Master>
  );
};

export default Routes;
